import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import Seo from "../../components/_UI/seo";
import AcademyS1 from "../../components/academyS1";
import AcademyS2 from "../../components/academyS2";
import AcademyS3 from "../../components/academyS3";
import AcademyS4 from "../../components/academyS4";
import AcademyS5 from "../../components/academyS5";
import AcademyS6 from "../../components/academyS6";



const AcademyPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Академия')}/>
            <div className={`${Styles.contentWrap}`}>
                <AcademyS1/>
                <AcademyS2/>
                <AcademyS3/>
                <AcademyS4/>
                <AcademyS5/>
                <AcademyS6/>
            </div>
        </section>
    );
};

export default AcademyPage;
